(function(Menu) {
    'use strict';

    var Helper = window.Helper || {};

    Menu.dropdown = function() {
        var $dropdowns = $('.js-dropdown');

        $dropdowns.each(function() {

            var $dropdown = $(this);
            var $trigger = $dropdown.find('.js-dropdown-trigger');

            $trigger.on('click', function(event) {
                event.preventDefault();

                $dropdown.toggleClass('is-active');
            });
        });
    };

    Menu.initToggle = function() {
        var $toggle = $('.js-menu-toggle');
        var $menu = $('.js-menu-overlay');
        var $icon = false;

        $toggle.on('click', function(event) {
            event.preventDefault();

            $menu.toggleClass('is-hidden');

            if ($icon) {
                $menu.toggleClass('is-active');
            }
        });
    };

    Menu.mimicMenu = function() {
        var $menu = $('.js-mimic-menu');
        var $targetMenu = $('.js-mimic-menu-target');

        var $lis = $menu.children('li');
        var $targetLis = $targetMenu.children('li').children('a');

        var includePadding = -1;

        $targetLis.each(function(index) {

            // Use native getComputedStyle so we get a float and not a rounded number
            // more info: http://stackoverflow.com/questions/11907514/getting-the-actual-floating-point-width-of-an-element
            var targetWidth = window.getComputedStyle($targetLis[index]).width;
            var targetPaddingLeft = window.getComputedStyle($targetLis[index]).paddingLeft;

            // IE doesn't check box-sizing of element and does not include padding/border when using .width.
            // On the first iteration check if padding/border is inlcuded with .width
            if (includePadding === -1) {
                includePadding = Menu.checkOuterWidth(targetWidth, $(this).outerWidth());
            }

            // add padding to width
            if (includePadding) {
                targetWidth = Helper.getFloat(targetWidth) + (Helper.getFloat(targetPaddingLeft) * 2);
            }

            $($lis[index]).css({
                'padding-left': targetPaddingLeft,
                'width': targetWidth
            });
        });
    };

    // check the native width with jQuery outerWidth
    // if it's not the same than; padding/border is not included
    Menu.checkOuterWidth = function(width, $outerWidth) {
        if (Math.round(Helper.getFloat(width)) === $outerWidth) {
            return false;
        }

        return true;
    };

})(window.Way2web.Menu = window.Way2web.Menu || {});
